import { observable_component } from 'common/util/ComponentDecorator';

@observable_component
export default class FormgroupDecorator {
	static classname = 'js-formgroup-decorator';

	constructor($input) {
		this.$input = $input;
		this.label = this.$input.data('label');
		this.is_required = !!this.$input.data('required');
		this.is_textarea = $input.is('textarea');
		this.value = this.$input.val();
		this.tip = this.$input.data('tip');

		this.initFormgroup();
	}

	build$Formgroup() {
		const $formgroup = $('<div class="formgroup"/>');

		if (this.is_required) {
			$formgroup.addClass('formgroup--required');
		}

		if (this.is_textarea) {
			$formgroup.addClass('formgroup--textarea');
		}

		const $label = $('<div class="formgroup__label"/>').html(this.label);
		const $placeholder = $('<div class="formgroup__placeholder"/>').html(this.label);

		$formgroup.append($label);
		$formgroup.append($placeholder);

		this.$input.removeClass('js-formgroup-decorator').addClass('formgroup__input');
		this.$input.wrap('<div/>');
		const $parent = this.$input.parent();
		$formgroup.append(this.$input);

		if (this.tip) {
			const $tip = $('<div class="formgroup__tip"/>').html(this.tip);
			$formgroup.append($tip);
		}

		$parent.append($formgroup);

		return $formgroup;
	}

	initFormgroup() {
		if (!this.$input.is('input') && !this.$input.is('textarea')) {
			return;
		}

		const $formgroup = this.build$Formgroup();
		//this.$input.after($formgroup);
		//this.$input.remove();

		Update($formgroup);
	}
}
